import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RptloanpopupComponent } from "../../../shared/popup/rptloanpopup/rptloanpopup.component";

import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { PrintloanreceiptService } from "../../../shared/print/printloanreceipt.service";

@Component({
  selector: 'app-rptloanreceiptpopup',
  templateUrl: './rptloanreceiptpopup.component.html',
  styleUrls: ['./rptloanreceiptpopup.component.css']
})

export class RptloanreceiptpopupComponent implements OnInit {

  LoanTypeList: any[] = [];
  SchemeList: any[] = [];
  BranchList: any[] = [];
  CentreList: any[] = [];
  CategoryList: any[] = [];

  constructor(public dialogRef: MatDialogRef<RptloanpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private CommonmastersService: CommonmastersService,
    private printloanreceiptService: PrintloanreceiptService,
    ) { }

  ngOnInit() {

    this.GetScheme()
    this.GetLoanType();
    this.GetBranch();
    this.GetCategory();

    this.data.BranchId = 0;
    this.data.CentreId = 0;
    this.data.StatusId = 0;
  }

  GenerateReports(): void {
    this.data.ReportName = "LoanReceiptsReport"; // 1.closure and reciepts/day
    this.printloanreceiptService.GenerateReport(this.data);
    this.dialogRef.close();
  }

  GetScheme() {
    this.CommonmastersService.FetchScheme().subscribe(data => {
      this.SchemeList = data;
    })
  }

  GetLoanType() {
    this.CommonmastersService.FetchLoanType().subscribe(data => {
      this.LoanTypeList = data;
    })
  }

  GetCategory() {
    this.CommonmastersService.GetCategoryList().subscribe(data => {
      this.CategoryList = data;
    })
  }

  GetBranch() {
    this.CommonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
      this.data.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];

       //auto selecting the centre based on branch selected.
       this.SelectCentre(this.data.BranchId)
    })
  }

  SelectCentre(branchId : any){
    this.CommonmastersService.FetchCentersBybranchId(branchId).subscribe(data => {
      this.CentreList = data;
    })
  }

}

